import * as React from 'react';
import MenuItemComponent from './MenuItem';
import styles from './Header.module.css';
export default function MenuGroupComponent(_a) {
    var group = _a.group, close = _a.close;
    return (React.createElement("section", null,
        group.title && (React.createElement("span", { className: styles.menuGroupTitle }, group.title)),
        React.createElement("div", { className: styles.menuGroup }, group.items.map(function (item, index) { return (React.createElement(MenuItemComponent, { key: index, item: item, close: close })); }))));
}
